import { DriverTableData } from '../../table/driver-table';
import { DriverDetailsFormItem } from '../types';

// Small transform to prepare data from reneal/mta drivers for the DriverTable component
export const getDriverTableData = (drivers?: DriverDetailsFormItem[]): DriverTableData => {
	if (drivers) {
		return drivers.map((item) => ({
			name: `${item.firstName} ${item.lastNames}`,
			mainDriver: item.isMainDriver,
			isProposer: item.relationshipToProposer === 'P',
		}));
	}
	return [];
};
